import { setQueryParams } from "../../Routing/state";
import { limitSelector } from './selectors';
export var updateSearchParam = function updateSearchParam(search) {
  return setQueryParams({
    search: search,
    offset: undefined
  });
};
export var updateLimitParam = function updateLimitParam(limit) {
  return setQueryParams({
    limit: limit,
    offset: undefined
  }, {
    saveToHistory: true
  });
};
export var updatePageParam = function updatePageParam(page) {
  return function (dispatch, getState) {
    var limit = limitSelector(getState());
    var offset = limit * page;
    var offsetParam = offset === 0 ? undefined : offset;
    return dispatch(setQueryParams({
      offset: offsetParam
    }, {
      saveToHistory: true
    }));
  };
};